import script from "./VerbalPlayView.vue?vue&type=script&setup=true&lang=js"
export * from "./VerbalPlayView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__